import React, { useState, useMemo } from "react";
import {
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  InputAdornment,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { placeholderCatalog } from "../../constants/placeholderCatalog";

export default function PlaceholderPicker({ onSelect }) {
  const [search, setSearch] = useState("");

  const filteredCatalog = useMemo(() => {
    if (!search) return placeholderCatalog;

    const lowerSearch = search.toLowerCase();
    return placeholderCatalog
      .map((cat) => ({
        ...cat,
        placeholders: cat.placeholders.filter(
          (p) =>
            p.label.toLowerCase().includes(lowerSearch) ||
            p.key.toLowerCase().includes(lowerSearch)
        ),
      }))
      .filter((cat) => cat.placeholders.length > 0);
  }, [search]);

  return (
    <Box sx={{ width: 320, p: 1 }} data-testid="placeholder-picker">
      <TextField
        fullWidth
        size="small"
        placeholder="Zoek placeholder..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        variant="outlined"
        sx={{ mb: 1 }}
        inputProps={{ "data-testid": "placeholder-search-input" }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        autoFocus
      />
      <List
        sx={{
          maxHeight: 300,
          overflow: "auto",
          "& .MuiListSubheader-root": {
            lineHeight: "32px",
            bgcolor: "background.paper",
            fontWeight: "bold",
            color: "primary.main",
          },
        }}
        dense
        data-testid="placeholder-list"
      >
        {filteredCatalog.length === 0 && (
          <Typography variant="body2" sx={{ p: 2, textAlign: "center", color: "text.secondary" }}>
            Geen resultaten gevonden
          </Typography>
        )}
        {filteredCatalog.map((category) => (
          <React.Fragment key={category.category}>
            <ListSubheader disableSticky>{category.category}</ListSubheader>
            {category.placeholders.map((p) => (
              <ListItem
                button
                key={p.key}
                onClick={() => onSelect(p)}
                sx={{
                  "&:hover": {
                    bgcolor: "action.hover",
                  },
                }}
                data-testid={`placeholder-item-${p.key}`}
              >
                <ListItemText
                  primary={p.label}
                  primaryTypographyProps={{ variant: "body2" }}
                  secondaryTypographyProps={{ variant: "caption" }}
                />
              </ListItem>
            ))}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
}
